import React from 'react';
import { usePlanningActualState } from '../Context/index';

const MarkdownTotal = ({ years }) => {
  const { checkVisible, getOvarAllFieldTotal } = usePlanningActualState();
  const markDownOptions = [
    {
      keyName: 'plannedMarkdown',
      name: 'Planned Markdown',
    },
    {
      keyName: 'actualMarkdown',
      name: 'Actual Markdown',
    },
  ];
  return (years ?? []).map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {markDownOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {markDownOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  });
};
export default MarkdownTotal;
